export default __webpack_public_path__ + "static/media/download.4513dab9.svg";